import { render, staticRenderFns } from "./ChallengeTeamsTab.vue?vue&type=template&id=2ee3419e&scoped=true"
import script from "./ChallengeTeamsTab.vue?vue&type=script&lang=ts"
export * from "./ChallengeTeamsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3419e",
  null
  
)

export default component.exports